import { useRouter } from "next/router";

import { useTranslator } from "@eo-locale/react";

import useEmbeds from "./useEmbeds";
import usePinned from "./usePinned";
import { useToast } from "@/storybook-components";

const useLogout = () => {
  const toast = useToast();
  const router = useRouter();
  const { isPinned } = usePinned();
  const { translate } = useTranslator();
  const { isInsideIframeAndOnCurrentUrl } = useEmbeds();

  const reloadPage = () => {
    if (isInsideIframeAndOnCurrentUrl || isPinned) {
      window.parent.location.reload();
      return;
    }
    router.reload();
  };

  const logOut = async () => {
    const response = await fetch("/admin/api/auth/logout", {
      method: "DELETE"
    });

    if (response.ok) {
      reloadPage();
      return;
    } else {
      return toast({
        id: "logout-error-toast",
        title: translate("errors.sorrySomethingWentWrong"),
        status: "error",
        isClosable: true
      });
    }
  };

  return { logOut };
};

export default useLogout;
